import axiosInstance from "../axiosClient";
// const { id } = useParams();

export const submitOperation = async (token, operationDetails, userId, organizationId = null) => {
    try {
        const response = await axiosInstance.post(
            `/operations/create_operation/${userId}`,
            {
                selected_date_time: operationDetails.selected_date_time,
                op_end_datetime: operationDetails.op_end_datetime,
                selected_timezone: operationDetails.selected_timezone,
                duration: operationDetails.duration,
                operator_name: operationDetails.operator_name,
                operator_faa_id: operationDetails.operator_faa_id,
                operator_email: operationDetails.operator_email,
                operator_phone: operationDetails.operator_phone,
                operation_type: operationDetails.operation_type,
                boundary_polygon_geojson: operationDetails.boundary_polygon_geojson,
                point_location_geojson: operationDetails.point_location_geojson,
                operation_metadata: operationDetails.operation_metadata,
                organizationId: organizationId // Pass organization context
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const preCheckOperation = async (token, startTime, endTime, timeZone, userId) => {

    try {


        const response = await axiosInstance.post(
            `/operations/precheck_operation/${userId}`,
            {
                selected_date_time: startTime,
                op_end_datetime: endTime,
                selected_timezone: timeZone
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const preInvalidCheckOperation = async (token, userId) => {

    try {

        const response = await axiosInstance.post(
            `/operations/invalid_cancel/${userId}`,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const isEmailVerifiedOperation = async (token, email) => {

    try {
        const response = await axiosInstance.get(
            `/auth/email_verification_status/${email}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }
        );
        if (response.data.emailVerified) {
            return response.data?.emailVerified;
        } else {
            return false;
        }
    } catch (error) {
        throw error;
    }


};